import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

// Add withCredentials only for auth-related requests
api.interceptors.request.use((config) => {
  if (config.url?.includes("/auth/")) {
    config.withCredentials = true;
  }
  return config;
});

// Display price overrides (keyed by Shopify handle/id). Keeps storefront + cart consistent.
const PRICE_OVERRIDES = {
  "racer-jersey": 100,
  "racer-longsleeve": 115,
  "racer-track-pants": 109,
  "nightcall-tee": 85,
};

function normalizeProduct(p) {
  if (!p || typeof p !== "object") return p;
  // Strip promotional "- ONLY X LEFT" suffix from names
  if (typeof p.name === "string") {
    p.name = p.name.replace(/\s*[-–—]?\s*ONLY\s+\d+\s+LEFT\s*/i, "").trim();
  }
  const override = PRICE_OVERRIDES[p.id];
  if (override != null) {
    p.price = override;
    if (Array.isArray(p.variants)) p.variants = p.variants.map((v) => ({ ...v, price: override }));
  }
  return p;
}

const HIDDEN_PRODUCT_IDS = ["blackout-box-only-50"];

api.interceptors.response.use(
  (res) => {
    if (res.config?.url?.includes("/shopify/products")) {
      if (Array.isArray(res.data)) res.data = res.data.filter((p) => !HIDDEN_PRODUCT_IDS.includes(p?.id) && !p?.is_gift_card).map(normalizeProduct);
      else if (res.data && typeof res.data === "object") res.data = normalizeProduct(res.data);
    }
    return res;
  },
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url?.includes("/auth/")) {
      original._retry = true;
      try {
        await axios.post(`${BACKEND_URL}/api/auth/refresh`, {}, { withCredentials: true });
        return api(original);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
